import {
	BusinessLongDateFormat,
	BusinessShortDateFormat,
} from '@core/util/datetime';
import { Font } from '@models/font';
import { SignatureHeight } from '@models/businesses';
import {
	AddressFormat,
	LongDateFormat,
	ShortDateFormat,
} from '@models/businessSettings/businessFormatTypes';
import { format } from 'date-fns';
import { DropdownOption } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';

export const FontDropdownOptions: DropdownOption<Font>[] = [
	{
		name: 'Arial',
		value: Font.ARIAL,
	},
	{
		name: 'Calibri',
		value: Font.CALIBRI,
	},
	{
		name: 'Courier New',
		value: Font.COURIER_NEW,
	},
	{
		name: 'Helvetica',
		value: Font.HELVETICA,
	},
	{
		name: 'Nunito',
		value: Font.NUNITO,
	},
	{
		name: 'Palatino Linotype',
		value: Font.PALATINO_LINOTYPE,
	},
	{
		name: 'Roboto',
		value: Font.ROBOTO,
	},
	{
		name: 'Tahoma',
		value: Font.TAHOMA,
	},
	{
		name: 'Time New Roman',
		value: Font.TIMES_NEW_ROMAN,
	},
];

export const SignatureHeightDropdownOptions: DropdownOption<SignatureHeight>[] =
	[
		{
			name: 'Small',
			value: SignatureHeight.SMALL,
		},
		{
			name: 'Medium',
			value: SignatureHeight.MEDIUM,
		},
		{
			name: 'Large',
			value: SignatureHeight.LARGE,
		},
	];

export const AddressFormatDropdownOptions: DropdownOption<AddressFormat>[] = [
	{
		name: 'Format 1',
		value: AddressFormat.FORMAT_1,
	},
	{
		name: 'Format 2',
		value: AddressFormat.FORMAT_2,
	},
	{
		name: 'Format 3',
		value: AddressFormat.FORMAT_3,
	},
	{
		name: 'Format 4',
		value: AddressFormat.FORMAT_4,
	},
];

export const FontSizeDropdownOptions: DropdownOption<number>[] = [
	{
		name: '8',
		value: 8,
	},
	{
		name: '9',
		value: 9,
	},
	{
		name: '10',
		value: 10,
	},
	{
		name: '11',
		value: 11,
	},
	{
		name: '11.5',
		value: 11.5,
	},
	{
		name: '12',
		value: 12,
	},
	{
		name: '12.5',
		value: 12.5,
	},
	{
		name: '13',
		value: 13,
	},
	{
		name: '14',
		value: 14,
	},
	{
		name: '15',
		value: 15,
	},
	{
		name: '16',
		value: 16,
	},
];

export const FontLineHeightDropdownOptions: DropdownOption<number>[] = [
	{
		name: '1',
		value: 1,
	},
	{
		name: '1.1',
		value: 1.1,
	},
	{
		name: '1.2',
		value: 1.2,
	},
	{
		name: '1.3',
		value: 1.3,
	},
	{
		name: '1.4',
		value: 1.4,
	},
	{
		name: '1.5',
		value: 1.5,
	},
];

const currentYear = new Date().getFullYear();

export const ShortDateOptions: DropdownOption<ShortDateFormat>[] = [
	{
		name: format(
			new Date(currentYear, 1, 1),
			BusinessShortDateFormat[ShortDateFormat.ONE],
		),
		value: ShortDateFormat.ONE,
	},
	{
		name: format(
			new Date(currentYear, 1, 1),
			BusinessShortDateFormat[ShortDateFormat.TWO],
		),
		value: ShortDateFormat.TWO,
	},
	{
		name: format(
			new Date(currentYear, 1, 1),
			BusinessShortDateFormat[ShortDateFormat.THREE],
		),
		value: ShortDateFormat.THREE,
	},
	{
		name: format(
			new Date(currentYear, 1, 1),
			BusinessShortDateFormat[ShortDateFormat.FOUR],
		),
		value: ShortDateFormat.FOUR,
	},
];

export const LongDateOptions: DropdownOption<LongDateFormat>[] = [
	{
		name: format(
			new Date(currentYear, 1, 1),
			BusinessLongDateFormat[LongDateFormat.ONE],
		),
		value: LongDateFormat.ONE,
	},
	{
		name: format(
			new Date(currentYear, 1, 1),
			BusinessLongDateFormat[LongDateFormat.TWO],
		),
		value: LongDateFormat.TWO,
	},
	{
		name: format(
			new Date(currentYear, 1, 1),
			BusinessLongDateFormat[LongDateFormat.THREE],
		),
		value: LongDateFormat.THREE,
	},
	{
		name: format(
			new Date(currentYear, 1, 1),
			BusinessLongDateFormat[LongDateFormat.FOUR],
		),
		value: LongDateFormat.FOUR,
	},
];

export enum BusinessFeeSettingsFirestorePaths {
	ESigning = 'eSigning.feeSettings',
	IDV = 'idv.feeSettings',
	Assyst = 'mortgages.assystFee',
}

export enum BusinessSettingsCardProvidersFirestorePaths {
	ESigning = 'eSigning',
	IDV = 'idv',
	TitleInsurance = 'titleInsurance',
}

export enum CollapsableBusinessSettingsSection {
	LTT_AND_MLTT = 'LTT & MLTT',
	TITLE_SEARCH = 'Title Search',
	TITLE_INSURANCE = 'Title Insurance',
	ID_VERIFICATION = 'ID Verification',
	E_SIGNING = 'E-Signing',
	ASSYST_FEES = 'Assyst Fees',
	INSTRUMENT_REGISTRATION = 'Instrument Registration',
}

export interface CollapsedChangeData {
	sectionName: CollapsableBusinessSettingsSection;
	collapsed: boolean;
}

export type SectionCollapsedStates = {
	[key in CollapsableBusinessSettingsSection]: boolean;
};
